import { useState } from "react";

const navItems = [
  { label: "事件归档", href: "#archive" },
  { label: "首发追踪", href: "#trace" },
  { label: "平台分布", href: "#platform" },
  { label: "讨论区", href: "#discussion" },
  { label: "归档说明", href: "#notes" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center gap-4">
          <a href="#top" className="flex shrink-0 items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-fire-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">黑料照片</h1>
              <span className="zone-label mt-1 hidden text-[10px] text-foreground-500 sm:block">
                SOURCE TRACE ARCHIVE
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            <div className="relative hidden md:flex md:w-56 lg:w-64">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
              <input
                type="text"
                placeholder="搜索事件编号 / 首发平台"
                className="w-full rounded-md border border-background-300 bg-background-100 py-2 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none focus:ring-2 focus:ring-primary-400"
              />
            </div>
            <a
              href="#discussion"
              className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 md:inline-flex"
            >
              <i className="ri-add-line"></i>
              投稿线索
            </a>
            <button
              type="button"
              aria-label="打开导航菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="relative mb-3 flex w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400"></i>
            <input
              type="text"
              placeholder="搜索事件编号 / 首发平台"
              className="w-full rounded-md border border-background-300 bg-background-100 py-2 pl-9 pr-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
          </div>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md border border-background-200 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#discussion"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-1.5 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className="ri-add-line"></i>
            投稿线索
          </a>
        </div>
      ) : null}
    </header>
  );
}